module.exports = __webpack_public_path__ + "img/toplogo.d85d0662.png";